import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_fumigation from "../../../assets/images/fumignation_icon.png";
import N_wws_Stockpoint from "../../../assets/images/stock.png";
import N_wws_Procurement from "../../../assets/images/feild_icon.png";
import N_wws_Export from "../../../assets/images/export_assist_icon.png";
import test_icon from "../../../assets/images/test_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

class OurStory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya is one of the best post-harvest solutions platforms for a farmer Producer organization It is an online agriculture marketplace to connect farmers, suppliers, and buyers online.";
    return (
      <React.Fragment>
        <Helmet>
          <title>Who we Serve | Farmer Producer Organizations | Arya</title>
          {/* <meta name="keywords" content="Get loan on agri products, Get loan on agri commodities, Get loan on wheat,  Get loan on paddy,  Get loan on cotton,  Get loan on sugar, Get loan on maize, Get loan on pulses" /> */}
        </Helmet>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>
        <section className="Whoweservebanner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <Link to="/" onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>{" "}
                <span>→</span>{" "}
                <Link
                  to="/WhoWeServe"
                  onClick={() => this.props.history.push("/WhoWeServe")}
                >
                  <MultiLanguageTranslation title="Who We Serve" />
                </Link>{" "}
                <span>→</span>
                <span className="breadcrumb_active">
                  <MultiLanguageTranslation title="Farmer Producer Organizations" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="Farmers & Farmer Producer Organizations" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="who_we_serve_page_title_of_the_total_cultivable" />
                  </p>
                  <p>
                    <MultiLanguageTranslation title="who_we_serve_page_title_It_work_with" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_wws_offer_por">
          <Container>
            <Row>
              <Col>
                <div className="N_wws_offer">
                  <div className="N_wws_offer_heading">
                    <h4>
                      <MultiLanguageTranslation title="OUR SERVICES" />
                    </h4>
                  </div>
                  <div className="N_wws_offer_content-sec">
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_warehousing} />
                      <h5>
                        <MultiLanguageTranslation title="Warehousing" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_fumigation} />
                      <h5>
                        <MultiLanguageTranslation title="Fumigation" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={test_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Testing & Assaying" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Stockpoint} />
                      <h5>
                        <MultiLanguageTranslation title="Warehouse & Stockpoint Audits" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        {" "}
                        <MultiLanguageTranslation title="Buy grain from farmer" />{" "}
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Export} />
                      <h5>
                        <MultiLanguageTranslation title="Export Assistance" />
                      </h5>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <ServiceContact />

        <section className="formContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <MultiLanguageTranslation title="ARYA Maximizing Support to Farmer Producer Organisations" />
                </h1>

                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="fpo_p1" />
                  ) : (
                    <>
                      An <b>FPO</b> is a farmer-only organization. The{" "}
                      <b>Farmers Producers Organization </b> covers all
                      agricultural inputs. This includes marketing, processing,
                      and technical support.
                    </>
                  )}
                </p>
                <p>
                  <MultiLanguageTranslation title="fpo_p2" />
                </p>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="fpo_p3" />
                  ) : (
                    <>
                      To reach its smallholder members, it works via the{" "}
                      <b>FPO farmer producer organization</b>.
                    </>
                  )}
                </p>

                <h2>
                  <MultiLanguageTranslation title="A food producer organization such as ours offers" />
                  :
                </h2>
                <ul>
                  <li>
                    <MultiLanguageTranslation title="Warehousing" />
                  </li>
                  <li>
                    <MultiLanguageTranslation title="Fumigation" />
                  </li>
                  <li>
                    <MultiLanguageTranslation title="QA Testing" />
                  </li>
                  <li>
                    <MultiLanguageTranslation title="S&W Inspected" />
                  </li>
                  <li>
                    <MultiLanguageTranslation title="Buy grain straight from the farmer" />
                  </li>
                  <li>
                    <MultiLanguageTranslation title="Export Help" />
                  </li>
                </ul>
                <h3>
                  <MultiLanguageTranslation title="Arya's farmers producing organization benefits" />
                  :
                </h3>
                <ul>
                  <li>
                    <p>
                      <strong>
                        <MultiLanguageTranslation title="Our authenticity Boost" />
                      </strong>
                      <br />
                      <MultiLanguageTranslation title="fpo_p4" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        <MultiLanguageTranslation title="Limitations of liability and legal personality we have" />
                      </strong>
                      <br />
                      <MultiLanguageTranslation title="fpo_p5" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        <MultiLanguageTranslation title="Inheritance" />
                      </strong>
                      <br />
                      <MultiLanguageTranslation title="fpo_p6" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        <MultiLanguageTranslation title="Easy registration and management" />
                      </strong>
                      <br />
                      <MultiLanguageTranslation title="fpo_p7" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>
                        <MultiLanguageTranslation title="Now accepting deposits" />
                      </strong>
                      <br />
                      <MultiLanguageTranslation title="fpo_p8" />
                    </p>
                  </li>
                </ul>
                <p>
                  <MultiLanguageTranslation title="fpo_p9" />
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default OurStory;
